import type { Confidence } from '../../lib/initial-form';

const STYLES: Record<Confidence, { dot: string; title: string }> = {
  high: { dot: 'bg-emerald-500', title: 'Haute confiance · fournisseur identifié' },
  medium: { dot: 'bg-amber-500', title: 'Confiance moyenne · à vérifier' },
  low: { dot: 'bg-red-500', title: 'Champ vide ou manquant' },
};

export function ConfidenceIndicator({ level }: { level: Confidence }) {
  const s = STYLES[level];
  return (
    <span
      className={`inline-block h-2.5 w-2.5 rounded-full ${s.dot}`}
      title={s.title}
      aria-label={s.title}
    />
  );
}
